/** @format */

// TODO: 신고하기 기능 추가하기
import React, { useState } from "react";
import useSettings from "stores/settings";
import { FormatDate } from "components/FormatDate";
import Link from "next/link";
import { BasicAlert } from "components/Alert";
import UserPhoto from "components/UserPhoto";
import UserName from "components/UserName";
import UserUid from "components/UserUid";
import { projectFirestore } from "components/ProjectFirestore";
import Tooltip from "@material-ui/core/Tooltip";
// Marerial Icon
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/Share";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import ReportOutlinedIcon from "@material-ui/icons/ReportOutlined";
import ContactSupportOutlinedIcon from "@material-ui/icons/ContactSupportOutlined";

import ShareModal from "components/modal/ShareModal";
import LoginModal from "components/modal/LoginModal";
import InquireModal from "components/modal/InquireModal";
import ReportModal from "components/modal/ReportModal";
import ArchiveModal from "components/modal/ArchiveModal";

const AppHeader = ({ email, appId, appName, price, createdAt, oneLineContent }) => {
  const photoUrl = UserPhoto(email);
  const appUserName = UserName(email);
  const userUid = UserUid(email);

  const [modalVisible1, setModalVisible1] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);
  const [modalVisible3, setModalVisible3] = useState(false);
  const [loginModalVisible, setLoginModalVisible] = useState(false);

  // useEffect(() => {
  //   if (settings.email) {
  //     // 보관함 체크
  //     const docRef = projectFirestore.collection("gcf").doc(email).collection("app").doc(appId).collection("archive").doc(settings.email);
  //     docRef
  //       .get()
  //       .then((doc) => {
  //         if (doc.exists) {
  //           setArchive(doc.data().createdAt);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("Error getting document:", error);
  //         BasicAlert(error);
  //       });
  //   }
  // }, []);

  /* 보관함 버튼 클릭 */
  // const handleClickArchive = async () => {
  //   /** 보관함 버튼 클릭하면 생성 */
  //   if (archive) {
  //     setModalVisible1(true);
  //   } else {
  //     const createdAt = FormatDate(new Date());
  //     setArchive(createdAt);
  //     try {
  //       const docRefApp = projectFirestore
  //         .collection("gcf")
  //         .doc(email)
  //         .collection("app")
  //         .doc(appId)
  //         .collection("archive")
  //         .doc(settings.email);
  //       const docRefUser = projectFirestore.collection("users").doc(settings.email).collection("archive").doc(appId);
  //       const values = {
  //         createdAt,
  //         appId: appId,
  //         appName: appName,
  //         previewInput: previewInput,
  //         previewOutput: previewOutput,
  //         price: price,
  //         email: email,
  //         userName: userName,
  //       };
  //       await docRefApp.set(values);
  //       await docRefUser.set(values);
  //       await setModalVisible1(true);
  //     } catch (error) {
  //       console.log(error);
  //       BasicAlert("보관함 생성 실패");
  //     }
  //   }
  // };

  /* Modal */
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div className="sm:flex justify-between items-start p-3 aiso_detail_header">
        <div className="flex justify-start items-start">
          <Link href={`/user/profile/${userUid}`}>
            <div>
              <div
                className="img-cover-box rounded-full min-w-min bg-white border-2 border-white"
                style={{ width: "50px", height: "50px" }}
              >
                <img src={photoUrl} alt="profile" className="w-full" />
              </div>
            </div>
          </Link>
          <div className="whitespace-pre-line break-all pl-3 mt-1">
            <p className="truncate-1-lines mb-0 font-gmarket-medium text-base font-bold">{appUserName}</p>
            <p className="mb-0 text-333 font-gmarket-medium text-sm">{createdAt ? createdAt.substring(0, 16) : ""}</p>

            {/* <p className="text-sm font-bold text-333 mb-0 break-all">{appName}</p> */}
          </div>
        </div>

        {/* 아이콘 영역 */}
        <div className="flex justify-end pt-2 sm:pt-0">
          {/* 보관함 주석 처리 */}
          <div className="mr-3 hidden">
            <Tooltip title="보관함에 추가">
              <IconButton color="primary" onClick={() => handleClickArchive()} className="p-2">
                <ShoppingCartOutlinedIcon className="text-333 " fontSize="medium" />
              </IconButton>
            </Tooltip>
          </div>
          <div className="mr-3">
            <Tooltip title="문의하기">
              <IconButton
                color="primary"
                onClick={() => {
                  setModalVisible2(true);
                }}
                className="p-2"
              >
                <ContactSupportOutlinedIcon className="text-333" />
              </IconButton>
            </Tooltip>
          </div>
          <div className="mr-3">
            <Tooltip title="신고하기">
              <IconButton
                color="primary"
                onClick={() => {
                  setModalVisible3(true);
                }}
                className="p-2"
              >
                <ReportOutlinedIcon className="text-333" />
              </IconButton>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="공유하기">
              <IconButton color="primary" onClick={handleOpen} className="p-2">
                <ShareIcon className="text-333" />
              </IconButton>
            </Tooltip>
            <ShareModal open={open} handleClose={handleClose} title={appName} description={oneLineContent} />
          </div>
        </div>
      </div>
      {/* Modal */}
      <ArchiveModal modalVisible={modalVisible1} setModalVisible={setModalVisible1} closeModal={() => setModalVisible1(false)} />
      <InquireModalContent
        modalVisible={modalVisible2}
        setLoginModalVisible={setLoginModalVisible}
        closeModal={() => setModalVisible2(false)}
        appId={appId}
        appName={appName}
        email={email}
        appUserName={appUserName}
        price={price}
      />
      <ReportModalContent
        modalVisible={modalVisible3}
        setLoginModalVisible={setLoginModalVisible}
        closeModal={() => setModalVisible3(false)}
        appId={appId}
        appName={appName}
        email={email}
        appUserName={appUserName}
        price={price}
      />
      <LoginModal modalVisible={loginModalVisible} closeModal={() => setModalVisible1(false)} />
    </div>
  );
};

/* 문의 모달 */
const InquireModalContent = ({ modalVisible, setLoginModalVisible, closeModal, appId, appName, email, appUserName, price }) => {
  const settings = useSettings();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const handleModalOkButton = async () => {
    /* 로그인 체크하고 로그인 후 이용해달라고 하기 */
    if (!settings.email) {
      setLoginModalVisible(true);
      return "";
    }

    const date = new Date();
    const createdAt = FormatDate(date);

    if (title === "") {
      const text = "문의 제목을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    if (content === "") {
      const text = "문의 내용을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    /**
     * 보낸 문의 저장 위치 : users/{ 보낸 사람 email }/inquireSend/{randomId}
     * 받은 문의 저장 위치 : users/{ 받는 사람 email }/inquireReceive/{randomId}
     * 앱 문의 저장 위치 : gcf/{ 받는 사람 email }/app/{appId}/inquire/{randomId}
     * 
     * 작성자 정보      앱 정보         문의 & 답변      답변 상태
     * email      |  appId       |  title     |  createdAt
       userName   |  appName     |  content   |  answeredAt
                  |  appEmail    |  category  |  status
                  |  appUserName |  answer
                  |  price
     */

    try {
      const values = {
        email: settings.email,
        userName: settings.name,
        appId,
        appName,
        appEmail: email,
        appUserName,
        price,
        title,
        content,
        answer: "",
        createdAt,
        answeredAt: "",
        status: "대기중",
      };

      const collectionRefAppUser = await projectFirestore.collection("users").doc(email).collection("inquireReceive");
      const newDoc = await collectionRefAppUser.add(values);

      const docRefUser = projectFirestore.collection("users").doc(settings.email).collection("inquireSend").doc(newDoc.id);
      const docRefApp = projectFirestore.collection("gcf").doc(email).collection("app").doc(appId).collection("inquire").doc(newDoc.id);
      await docRefUser.set(values);
      await docRefApp.set(values);

      setTitle("");
      setContent("");
      closeModal("");
    } catch (error) {
      console.log(error);
      BasicAlert("문의 등록 실패");
    }
  };
  return (
    <InquireModal
      modalVisible={modalVisible}
      closeModal={closeModal}
      handleModalOkButton={handleModalOkButton}
      title={title}
      setTitle={setTitle}
      content={content}
      setContent={setContent}
    />
  );
};

/* 신고 모달 */
const ReportModalContent = ({ modalVisible, setLoginModalVisible, closeModal, appId, appName, email, appUserName, price }) => {
  const settings = useSettings();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const handleModalOkButton = async () => {
    /* 로그인 체크하고 로그인 후 이용해달라고 하기 */
    if (!settings.email) {
      setLoginModalVisible(true);
      return "";
    }

    const date = new Date();
    const createdAt = FormatDate(date);

    if (title === "") {
      const text = "신고 제목을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    if (content === "") {
      const text = "신고 내용을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    /**
     * 보낸 신고 저장 위치 : users/{ 보낸 사람 email }/report/{randomId}
     * 받은 신고 저장 위치 : admin/report/app/{randomId}
     */

    try {
      const collectionRefAppUser = await projectFirestore.collection("admin").doc("report").collection("app");
      const values = {
        email: settings.email,
        userName: settings.name,
        appId,
        appName,
        appEmail: email,
        appUserName,
        price,
        title,
        content,
        createdAt,
        status: "미확인",
      };
      await collectionRefAppUser.add(values);
      // const docRefUser = await projectFirestore.collection("users").doc(settings.email).collection("report").doc(appUserDoc.id);
      // await docRefUser.set(values);
      setTitle("");
      setContent("");
      closeModal("");
    } catch (error) {
      console.log(error);
      BasicAlert("신고 등록 실패");
    }
  };
  return (
    <ReportModal
      modalVisible={modalVisible}
      closeModal={closeModal}
      handleModalOkButton={handleModalOkButton}
      title={title}
      setTitle={setTitle}
      content={content}
      setContent={setContent}
    />
  );
};

export default AppHeader;
